<template>
    <v-card class="border-lg border-primary border-opacity-100">
        <v-card-title>
            <TitleOfDialog title="Vehicles" @close="emit('close')" />
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-btn class="mb-3" width="100%" prepend-icon="mdi-plus-thick" color="primary"
                :disabled="!user_perms.find(e => e.name == 'create_vehicle')" @click="dialogAddVehicle = true">Add
                vehicle</v-btn>
            <v-data-table :loading="loading" :items-per-page-options="[10]" :items="vehicles || []"
                :items-length="vehicles.length" :headers="headers" @update:options="loadItems" class="elevation-1">
                <template v-slot:item.actions="{ item }">
                    <v-btn icon="mdi-eye" :disabled="!user_perms.find(e => e.name == 'show_vehicle')"
                        :to="`/admin/vehicle/${item.id}`" color="info" variant="text" @click="goToVehicle(item)">
                    </v-btn>
                    <v-btn :disabled="!user_perms.find(e => e.name == 'delete_vehicle')" icon color="error"
                        variant="text" @click="deleteVehicle(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.icon="{ item }">
                    <Icon :icon="item.icon" :color="item.boat_mark_color"></Icon>
                </template>

                <template v-slot:item.route_color="{ item }">
                    <div class="color-box" :style="{ backgroundColor: item.route_color }">
                        {{ item.route_color }}
                    </div>
                </template>

                <template v-slot:item.boat_waypoint_color="{ item }">
                    <div class="color-box" :style="{ backgroundColor: item.boat_waypoint_color }">
                        {{ item.boat_waypoint_color }}
                    </div>
                </template>

                <template v-slot:item.boat_mark_color="{ item }">
                    <div class="color-box" :style="{ backgroundColor: item.boat_mark_color }">
                        {{ item.boat_mark_color }}
                    </div>
                </template>


                <template v-slot:item.descriptive="{ item }">
                    <v-btn icon="mdi-file-document-multiple" :disabled="!user_perms.find(e => e.name == 'show_vehicle')"
                        color="info" variant="text"
                        @click="descriptiveInfoShow = item.descriptive; dialogShowDescriptive = true;">
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>

    <v-overlay v-model="dialogAddVehicle" location="top" style="justify-content:center;align-items: center;">
        <AddVehicleForm @close="dialogAddVehicle = false"></AddVehicleForm>
    </v-overlay>


    <v-overlay v-model="dialogDeleteVehicle" location="top" style="justify-content:center;align-items: center;">
        <ConfirmForm @close="dialogDeleteVehicle = false" @confirm="confirmDeleteVehicle()"
            :text="'Do you want to delete vehicle ' + vehicleToDelete.name + ' with mac ' + vehicleToDelete.mac"
            type-to-delete="Vehicle"></ConfirmForm>
    </v-overlay>

    <v-overlay v-model="dialogShowDescriptive" location="top" style="justify-content:center;align-items: center;">
        <DescriptiveInfo :descriptive="descriptiveInfoShow" @close="dialogShowDescriptive = false"></DescriptiveInfo>
    </v-overlay>

</template>

<style scoped></style>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useVehicleStore } from '@/store/vehicleStore';
import AddVehicleForm from '@/components/admin/forms/AddVehicleForm.vue';
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import ConfirmForm from '@/components/admin/forms/ConfirmForm.vue';
import { useRouter } from 'vue-router';
import Icon from '@/components/icons/Icon.vue';
import DescriptiveInfo from '@/components/admin/vehicles/DescriptiveInfo.vue';

const emit = defineEmits(['close']);
const props = defineProps({
    user_perms: Object
})
const dialogAddVehicle = ref(false);
const dialogDeleteVehicle = ref(false);
const dialogShowDescriptive = ref(false);
const descriptiveInfoShow = ref();

const vehicleToDelete = ref();

const headers = computed(() => [
    { title: "Name", align: 'left', sortable: false, key: 'name' },
    { title: 'Mark color', align: 'center', sortable: false, key: 'boat_mark_color' },
    { title: 'Waypoint color', align: 'center', sortable: false, key: 'boat_waypoint_color' },
    { title: 'Route color', align: 'center', sortable: false, key: 'route_color' },
    { title: 'Mac', align: 'center', sortable: false, key: 'mac' },
    { title: 'Descriptive file', align: 'center', sortable: false, key: 'descriptive' },
    { title: 'Icon', align: 'center', sortable: false, key: 'icon' },
    { title: 'Actions', align: 'center', sortable: false, key: 'actions' },
]);
const router = useRouter();
const loading = ref(true);
const vehicleStore = useVehicleStore();
const { vehicles } = storeToRefs(vehicleStore);
const loadItems = async () => {
    loading.value = true;
    await vehicleStore.fetchVehicles();
    loading.value = false;
}


const deleteVehicle = (vehicle) => {
    vehicleToDelete.value = vehicle;
    dialogDeleteVehicle.value = true;
};

const goToVehicle = (vehicle) => {
    router.push(`/admin/vehicle/${vehicle.id}`);
};

const confirmDeleteVehicle = async () => {
    try {
        await vehicleStore.deleteVehicle(vehicleToDelete.value.id);
        dialogDeleteVehicle.value = false;
    } catch (error) {
        console.error("Error en la validación o creación del usuario:", error);
    }
}

</script>

<style lang="css" scoped>
.color-box {
    max-width: 100px;
    max-height: 32px;
    padding: 6px 12px;
    border-radius: 4px;
    color: white;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>